import AppConstants from "../components/AppConstants";

let authToken = localStorage.getItem(AppConstants.JWT);

const config = {
    headers: {Authorization: `Token ${authToken}`}
  };
  
export default config;

